// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"2adb99ac","453":"632798b0","455":"b128582e","977":"864392e4"}[chunkId] + ".chunk.js";
};